import * as React from 'react';
import { useState, useRef, useMemo, useCallback, useEffect, createContext } from 'react';

const VerticalPositionContext = /*#__PURE__*/createContext(null);
function VerticalPositionProvider({
  children
}) {
  // Vertical center of the current selected item
  const [centerY, setCenterY] = useState(null);
  const selectedItemRef = useRef(null);

  // Updates centerY whenever the size of the container DOM element changes
  const resizeObserver = useMemo(() => new ResizeObserver(entries => {
    if (!selectedItemRef.current) return;
    const boundingRect = selectedItemRef.current.getBoundingClientRect();
    const centerYValue = boundingRect.top + boundingRect.height / 2;
    setCenterY(centerYValue);
  }), []);
  const onSelectItem = useCallback((el, id) => {
    // Deselect everything

    if (!el || el === selectedItemRef.current) {
      // @TODO - implement respect for togglePosition
      // for now, we just return here and maintain the indicator
      // if (togglePosition) {
      //   setCenterY(null)
      //   selectedItemRef.current = null
      // }

      return;
    }

    // Initially set the position and update the ref for the observer
    const boundingRect = el.getBoundingClientRect();
    const centerYValue = boundingRect.top + boundingRect.height / 2;
    setCenterY(centerYValue);
    selectedItemRef.current = el;
  }, []);
  const setContainerRef = useCallback(target => {
    if (target) {
      resizeObserver.observe(target);
    }
  }, []);
  useEffect(() => {
    return () => resizeObserver.disconnect();
  }, []);
  return /*#__PURE__*/React.createElement(VerticalPositionContext.Provider, {
    value: {
      centerY,
      onSelectItem,
      setContainerRef
    }
  }, children);
}
VerticalPositionProvider.displayName = "VerticalPositionProvider";

export { VerticalPositionContext, VerticalPositionProvider };
